import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children"];
import React from 'react';
import Box from 'components/Box';
function stopPropagation(event) {
  event.stopPropagation();
}
function InteractiveTableContent(_ref) {
  var children = _ref.children,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Box, _extends({}, otherProps, {
    display: "inline-flex",
    onClick: stopPropagation
  }), children);
}
export default InteractiveTableContent;